<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_viii"></a><a id="page_ix">ACKNOWLEDGMENTS</a></h2><a id="page_ix">
<p class="txf"><em>S</em>pecial thanks to: Waldo, a magnificent personal trainer; Sue, a wonderkind of a personal assistant; and Julietta, a slightly paranoid but dedicated chef.</p>
</a><p class="tx"><a id="page_ix">Thank you for contributing so many great tips and hints on fitness and organization, as well as hundreds of incredible (and easy!) recipes, to my new website, </a><a class="nounder" href="http://www.karenhawkins.com" target="_blank">www.karenhawkins.com</a>.</p>
<p class="tx">Because of you guys, www.karenhawkins.com rocks!</p>
<p class="pl1"><em><a id="page_1">Luxor, Egypt</a></em></p><a id="page_1">
<p class="dl"><em>April 12, 1822</em></p>
<p class="tx"> </p>
<p class="ltsal">Dearest Family,</p>
<p class="ltx">I write this in haste. As of last Tuesday, I am still in Egypt, the “guest” of a sufi who will not allow me to leave until I return an artifact I legitimately purchased from an antiquities dealer in Cairo.</p>
<p class="ltx">It galls me to return it, but it appears I must. William, as soon as you can, set out for Scotland to New Slains Castle and request my friend, the Earl of Erroll, to commend the artifact to your care. Then make all haste to deliver it to my trusty (if annoying) assistant, Miss Jane Smythe-Haughton, whom you met on your last visit. She is currently housed with the consulate in Malfi and awaits your arrival.</p>
<p class="ltx">Mother, do not worry. I have been in worse fixes and escaped unscathed. I fully intend on continuing that tradition.</p>
<p class="ltc">Yours,</p>
<p class="ltc2">Michael</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?68292af4